import { PButtonPure } from "@porsche-design-system/components-react"
import type { PropsWithChildren } from "react"
import { useCopyToClipboard } from "./hooks/useCopyToClipboard"

interface CopyToClipboardButtonProps {
	className?: string
	onCopied?: (value: string) => void // for tracking and other side effects
	size?: "xs"
	slot?: "end"
	successToastText?: string
	value: string
}

export const CopyToClipboardButton = ({
	children,
	className,
	onCopied,
	size,
	slot,
	successToastText,
	value,
}: PropsWithChildren<CopyToClipboardButtonProps>) => {
	const onClick = useCopyToClipboard({ onCopied, successToastText, value })

	return (
		<PButtonPure
			className={className}
			type="button"
			alignLabel="start"
			icon="copy"
			size={size}
			slot={slot}
			hideLabel={!children}
			data-testid="copy-button"
			onClick={onClick}
		>
			{children}
		</PButtonPure>
	)
}
